<div class="pad8">
  <h6
    class="padlr8 partial-border-top ion-no-margin title-text-color fs-4 font600"
  >
    {{ productCarouselInfo?.display_name }}
  </h6>
  <span class="padlr8 subtitle-text-color fs-1 font400"
    >{{ productCarouselInfo?.description }}
  </span>
  <div class="scrollx no-scroll">
    <div
      class="scroll-item ion-padding-vertical pad8"
      *ngFor="
        let item of productCarouselInfo?.products ||
          productCarouselInfo?.retailers || productCarouselInfo?.services
      "
    >
      <ion-card (click)="navigate(item)" class="ion-no-margin">
        <ion-img
          [src]="
            item?.img || item?.storeImage || 'https://picsum.photos/id/96/96'
          "
          class="store-img"
        ></ion-img>
        <div class="text-overlay">
          <ion-card-subtitle class="line-2-clip fs-2 font700 white-text-color">{{
            item?.title || item?.storeName
          }}</ion-card-subtitle>
        </div>
      </ion-card>
    </div>
  </div>
</div>
